export default __webpack_public_path__ + "static/media/logo.50932821.png";